import { Controller } from 'stimulus';

// Autosave only writes a backup snapshot (BoardDatum), not a real save, so only surface failures.
export default class extends Controller {
  static targets = ['failed'];

  disconnect() {
    clearTimeout(this.hideTimeoutID);
  }

  update({ detail }) {
    console.debug('[autosave]', detail.state);

    if (detail.state !== 'failed') {
      return;
    }

    this.failedTarget.classList.remove('!hidden');
    clearTimeout(this.hideTimeoutID);
    this.hideTimeoutID = setTimeout(() => this.failedTarget.classList.add('!hidden'), 1000 * 4);
  }
}
